export enum ProductOrderBy {
    ByNameAsc,
    ByNameDesc,
    ByPriceAsc,
    ByPriceDesc,
    Discounted,
    ByDateDesc,
    Recommended,
    ByAvailabilityDateAsc
}
